import { Link } from 'react-router-dom';
import './orderConfirmed.css';

const OrderConfirmed = () => {
  return (
    <div className="confirmation-page">
      <h1>🎉 Order Confirmed!</h1>
      <p>Thank you for your enquiry. We will contact you shortly.</p>
      <Link to="/products">
        <button className="back-to-products">Back to Products</button>
      </Link>
    </div>
  );
};

export default OrderConfirmed;
